/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown>, role: NonNullable<unknown> }} Uno_Confirm_Invite_MemberInputs */



/**
* | output |
* | --- |
* | "Invite {email} as {role}" |
*
* @param {Uno_Confirm_Invite_MemberInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_confirm_invite_member = /** @type {((inputs: Uno_Confirm_Invite_MemberInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Confirm_Invite_MemberInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.email} als ${i?.role} einladen`)
	return /** @type {LocalizedString} */ (`Invite ${i?.email} as ${i?.role}`)
});